/*
 * View for Category Info
 */

define(["marionette", "./template/categoryInfoTemplate.html"], function (
  Marionette,
  CategoryInfoTemplate,
) {
  var CategoryInfoView = {};

  CategoryInfoView.categoryInfoLayout = Marionette.Layout.extend({
    template: CategoryInfoTemplate,
    regions: {
      categoryValue: "#categoryValue",
    },
  });

  return CategoryInfoView;
});
